import type { OfferClickSearchParams } from 'tripPlanner/assistant/contexts/ChatMessageActionsContext'
import { hotelSearchResultParams } from 'tripPlanner/utils/hotelSearchResultParams'
import { isValidDates, isValidOccupancy } from 'tripPlanner/utils/streamedProgressiveUi'
import type { MessagePart } from './messageTypes'

/** A text link uses only explicit search context from a matching carousel in its own message. */
export function getMessageHotelLinkSearchParams(
  parts: ReadonlyArray<MessagePart>,
): ReadonlyMap<string, OfferClickSearchParams> {
  const searchParamsByOfferId = new Map<string, OfferClickSearchParams>()
  const seenOfferIds = new Set<string>()

  for (const part of parts) {
    if (part.type !== 'ui_component' || part.data.type !== 'carousel' || part.data.product !== 'hotel') continue

    const occupancy = isValidOccupancy(part.data.occupancy) ? part.data.occupancy : undefined
    const searchDates = isValidDates(part.data.dates) ? part.data.dates : undefined
    const searchParams = occupancy || searchDates
      ? hotelSearchResultParams({ searchDates, occupancy })
      : undefined
    for (const offerId of new Set(part.data.offerIds)) {
      if (seenOfferIds.has(offerId)) {
        searchParamsByOfferId.delete(offerId)
      } else {
        seenOfferIds.add(offerId)
        if (searchParams) searchParamsByOfferId.set(offerId, searchParams)
      }
    }
  }

  return searchParamsByOfferId
}
